import { render, staticRenderFns } from "./effect-analysis.vue?vue&type=template&id=20a909b5&scoped=true"
import script from "./effect-analysis.vue?vue&type=script&lang=js"
export * from "./effect-analysis.vue?vue&type=script&lang=js"
import style0 from "./effect-analysis.vue?vue&type=style&index=0&id=20a909b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a909b5",
  null
  
)

export default component.exports